import {DI_TOKENS} from '@/di/di.tokens';
import {GameStatusType} from '@/stores/GameStatusStore/GameStatusStore.constants';

import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {LoggerService} from '@/services/LoggerService/LoggerService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {GameStatusStore} from '@/stores/GameStatusStore/GameStatusStore';

export class GameStatusService {
  constructor(
    private readonly gameStatusStore: GameStatusStore,
    private readonly projectApi: IProjectApi,
    private readonly loggerService: LoggerService,
  ) {}

  public async fetchGameStatus(): Promise<void> {
    try {
      const response = await this.projectApi.gameStatus();

      this.gameStatusStore.setStatus(response.payload.status);
      this.gameStatusStore.setSuccessFetchStatus();
    } catch (error) {
      this.loggerService.logHttpError(error as HttpError);
      this.gameStatusStore.setErrorFetchData(error);
      this.gameStatusStore.setErrorFetchStatus();
    }
  }

  public setStatusActive(): void {
    this.gameStatusStore.setStatus(GameStatusType.Active);
  }

  public setStatusLeaguesRecalculation(): void {
    this.gameStatusStore.setStatus(GameStatusType.LeaguesRecalculation);
  }

  public setStatusGameFinishedBeforeResults(): void {
    this.gameStatusStore.setStatus(GameStatusType.GameFinishedBeforeResults);
  }

  public setStatusGameFinishedAfterResults(): void {
    this.gameStatusStore.setStatus(GameStatusType.GameFinishedAfterResults);
  }

  public clearFetchStatus(): void {
    this.gameStatusStore.setIdleFetchStatus();
  }

  public clearFetchErrorData(): void {
    this.gameStatusStore.clearErrorFetchData();
  }
}

injected(GameStatusService, DI_TOKENS.gameStatusStore, DI_TOKENS.projectApi, DI_TOKENS.loggerService);
